import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { LoaderService } from "./loader.service";
import { ActionResult, ActionResultList, RoleEdit, UserDetail } from "@model";
import { EnvironmentService } from "./environment.service";

@Injectable({ providedIn: 'root' })
export class OrganiserUsersService {
  constructor(
    private http: HttpClient,
    private loaderService: LoaderService,
    private environmentService: EnvironmentService
  ) {}

  findUsers(organiserId?: number): Observable<UserDetail[]> {
    return this.http.post<ActionResultList<UserDetail[], number>>(
      `${this.environmentService.getApiUrl()}/api/organiserusers/getusersdetails`,
      organiserId ?? null
    ).pipe(
      map(value => value?.result?.length ? value.result : [])
    );
  }

  addUser(email: string, roleId: number, organiserId?: number): Observable<boolean> {
    const roleEdit = new RoleEdit(email, undefined, roleId, organiserId);
    this.loaderService.startLoading();
    return this.http.post<ActionResult<boolean>>(
      `${this.environmentService.getApiUrl()}/api/organiserusers/editrole/email`,
      roleEdit
    ).pipe(
      map(value => value.result ?? false)
    );
  }

  editUser(userId: number, roleId: number, organiserId: number): Observable<boolean> {
    const roleEdit = new RoleEdit(undefined, userId, roleId, organiserId);
    return this.http.post<ActionResult<boolean>>(
      `${this.environmentService.getApiUrl()}/api/organiserusers/editrole/id`,
      roleEdit
    ).pipe(
      map(value => value.result ?? false)
    );
  }

  deleteUser(userId: number, organiserId: number): Observable<boolean> {
    const roleEdit = new RoleEdit(undefined, userId, undefined, organiserId);
    return this.http.post<ActionResult<boolean>>(
      `${this.environmentService.getApiUrl()}/api/organiserusers/removemember`,
      roleEdit
    ).pipe(
      map(value => value.result ?? false)
    );
  }
}
